export const baseurl = process.env.REACT_APP_OBC_BASEURL;
export const backend_url = process.env.REACT_APP_OBC_BACKEND;
export const accessdenied =
  'https://login.mercedes-benz.com/error/access-denied';
// "https://login-int.mercedes-benz.com/error/access-denied";
